import Archive from './Main'

const route = {
  path: '/archive',
  name: 'archive',
  component: Archive
}

export default route
